import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom/client";
import "./index.css";
import 'react-tooltip/dist/react-tooltip.css';
import { App } from "./app";
import { store } from "./store";
import { Provider } from "react-redux";
const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(_jsx(Provider, { store: store, children: _jsx(App, {}) }));
